module.exports = __webpack_public_path__ + "img/stop_btn.42ae86df.png";